<template>
    <img
      alt="banxa logo"
      src="@/assets/images/logos/banxa-logo-light@2x.png"
      class="logo logo-header__banxa__img"
      v-if="globalStore.global.theme !== 'LIGHT'"
    />
    <img
      alt="banxa logo"
      src="@/assets/images/logos/banxa-logo-dark@4x.png"
      class="logo logo-header__banxa__img"
      v-if="globalStore.global.theme === 'LIGHT'"
    />
</template>

<script setup>
import { useGlobalStore } from "@/stores/globalStore";
const globalStore = useGlobalStore();
</script>
